import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import Button from 'components/Buttons/Button/Button';
import { ButtonInner, ButtonWrapper } from 'components/Buttons/Button/Button.css';
import { fontNormal } from 'style/styled-components/cssGlobalVariables';

export const StyledButton = styled(Button)`
    min-width: auto;

    ${ButtonWrapper} {
        min-width: auto;
        overflow: visible;
    }

    ${ButtonInner} {
        min-width: auto;
        width: 40px;
        height: 40px;
        padding: 8px;
        border-radius: 999px;
        gap: 8px;
        background: var(--color-neutral-dark-body-10);
        border: 2px solid transparent;
        overflow: visible;

        &:not(.no-hover):hover {
            background: var(--color-dark-body-20);
            border: 2px solid transparent;

            .label {
                opacity: 1;
            }
        }

        .label {
            display: block !important;
            position: absolute;
            top: calc(100% + 10px);
            font-family: ${fontNormal};
            font-weight: 400;
            left: 50%;
            transform: translateX(-50%);
            font-size: 12px;
            line-height: 1.3;
            letter-spacing: 0.5%;
            white-space: nowrap;
            color: ${(props) => props.theme.brandedConfig.high_contrast};
            opacity: 0;
            transition: opacity 0.2s ease-in-out;
            pointer-events: none;
        }
    }

    .SVGInline {
        line-height: 0;
    }

    svg {
        width: 24px;
        height: 24px;
        flex-shrink: 0;

        path {
            fill: ${(props) => props.theme.brandedConfig.high_contrast};
        }
    }
`;
